import React from 'react'
import { instanceOf, func, bool } from 'prop-types'
import TargetLabelBody from './TargetLabelBody'
import TargetLabelHeader from './TargetLabelHeader'

const TargetLabelTable = ({
  selectedTargets,
  saveLabel,
  expressionList,
  loading,
}) => {
  return (
    <div className="de--label-table">
      <TargetLabelHeader selectedTargets={selectedTargets} />
      <TargetLabelBody
        saveLabel={saveLabel}
        expressionList={expressionList}
        loading={loading}
        selectedTargets={selectedTargets}
      />
    </div>
  )
}

TargetLabelTable.propTypes = {
  selectedTargets: instanceOf(Object),
  saveLabel: func,
  expressionList: instanceOf(Array),
  loading: bool,
}

export default TargetLabelTable